/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerChangeType,
  CashDrawerChangeTypeOptional,
  CashDrawerChangeTypeMetaI,
  CashDrawerChangeTypeTrackedI,
} from "./cash-drawer-change-type";
import {
  CashDrawerChangeTypeTracked,
  CashDrawerChangeTypeMeta,
} from "./cash-drawer-change-type";

/**
 *
 * @export
 * @interface CashDrawersChangeBase
 */
export interface CashDrawersChangeBaseOptional {
  /**
   *
   * @type {CashDrawerChangeType}
   * @memberof CashDrawersChangeBase
   */
  changeType?: CashDrawerChangeType;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeBase
   */
  amountCents?: number;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeBase
   */
  amountTendered?: number;
}

export interface CashDrawersChangeBase extends CashDrawersChangeBaseOptional {
  /**
   *
   * @type {CashDrawerChangeType}
   * @memberof CashDrawersChangeBase
   */
  changeType: CashDrawerChangeType;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeBase
   */
  amountCents: number;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeBase
   */
  amountTendered?: number;
}

export interface CashDrawersChangeBaseTrackedI {
  /**
   *
   * @type {CashDrawerChangeType}
   * @memberof CashDrawersChangeBase
   */
  changeType?: CashDrawerChangeType;
  changeTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeBase
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeBase
   */
  amountTendered?: number;
  amountTenderedIsSet: boolean;
}

transformDatesMap.set(
  "CashDrawersChangeBase",
  function (model: CashDrawersChangeBase) {},
);

export type CashDrawersChangeBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  changeType: PropertyMeta<CashDrawerChangeTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTendered: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CashDrawersChangeBaseMeta: CashDrawersChangeBaseMetaI =
  {} as CashDrawersChangeBaseMetaI;
CashDrawersChangeBaseMeta = typeMeta("CashDrawersChangeBase", {
  changeType: propertyMeta(
    "changeType",
    false,
    true,
    false,
    CashDrawerChangeTypeMeta,
  ),
  amountCents: propertyMeta(
    "amountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  amountTendered: propertyMeta(
    "amountTendered",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = CashDrawersChangeBaseMeta;

registerMeta(() => {});

export class CashDrawersChangeBaseTracked implements CashDrawersChangeBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  changeType__I?: CashDrawerChangeType = undefined;
  changeTypeIsSet: boolean = false;
  set changeType(v: undefined | CashDrawerChangeType) {
    if (v !== undefined) {
      this.changeType__I = v;
      this.changeTypeIsSet = true;
    } else {
      this.changeType__I = v || undefined;
      this.changeTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get changeType() {
    return this.changeType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  amountTendered__I?: number = undefined;
  amountTenderedIsSet: boolean = false;
  set amountTendered(v: undefined | number) {
    if (v !== undefined) {
      this.amountTendered__I = v;
      this.amountTenderedIsSet = true;
    } else {
      this.amountTendered__I = v || undefined;
      this.amountTenderedIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTendered() {
    return this.amountTendered__I;
  }
  constructor(config?: CashDrawersChangeBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CashDrawersChangeBaseOptional,
    options?: AssignOptions,
  ): CashDrawersChangeBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.changeType &&
      this.changeTypeApplyFilter(optionsRequired.filter)
    ) {
      this.changeType = config.changeType;
      if (optionsRequired.unassign) this.changeTypeIsSet = false;
      else this.changeTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (
      config.amountTendered &&
      this.amountTenderedApplyFilter(optionsRequired.filter)
    ) {
      this.amountTendered = config.amountTendered;
      if (optionsRequired.unassign) this.amountTenderedIsSet = false;
      else this.amountTenderedIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CashDrawersChangeBaseTrackedI {
    const cloned = {} as CashDrawersChangeBaseTrackedI;
    if (
      this.changeTypeIsSetDeep() &&
      this.changeTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.changeTypeIsSet = true;
      cloned.changeType = this.changeType;
    } else {
      //cloned.changeTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.amountTenderedIsSetDeep() &&
      this.amountTenderedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTenderedIsSet = true;
      cloned.amountTendered = this.amountTendered;
    } else {
      //cloned.amountTenderedIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CashDrawersChangeBaseTrackedI {
    if (!this.changeTypeApplyFilter(filter)) this.changeTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.amountTenderedApplyFilter(filter))
      this.amountTenderedIsSet = false;

    return this;
  }
  changeTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeBaseMeta.changeType,
      CashDrawersChangeBaseMeta,
      this.changeType,
      this,
    );
  }
  changeTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.changeTypeIsSet && this.changeTypeApplyFilter(filter)) return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeBaseMeta.amountCents,
      CashDrawersChangeBaseMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTenderedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeBaseMeta.amountTendered,
      CashDrawersChangeBaseMeta,
      this.amountTendered,
      this,
    );
  }
  amountTenderedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTenderedIsSet && this.amountTenderedApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.changeTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.amountTenderedIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
